module.exports = __webpack_public_path__ + "media/images/producers/producers-pg-bg-e6e25131810895781799e83e74287f46.jpg";